import SvgColor from '@components/svg-color/SvgColor';
import { PATH_DASHBOARD } from '@routes/paths';

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: icon('ic_blog'),
  cart: icon('ic_cart'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

const navConfig = [
  {
    subheader: 'Lịch khám & Bệnh nhân',
    items: [
      {
        title: 'Phiếu khám',
        path: PATH_DASHBOARD.managements.bookings,
        icon: ICONS.booking,
        children: [
          {
            title: 'Tạo phiếu khám',
            path: PATH_DASHBOARD.managements.bookingForm,
            id: 'create-booking',
          },
          { title: 'Danh sách', path: PATH_DASHBOARD.managements.bookings, id: 'list-booking' },
        ],
      },
      {
        title: 'Lịch khám',
        path: PATH_DASHBOARD.managements.schedules,
        icon: ICONS.calendar,
      },
      {
        title: 'Hồ sơ bệnh nhân',
        path: PATH_DASHBOARD.managements.patients,
        icon: ICONS.user,
      },
    ],
  },
  {
    subheader: 'Danh mục',
    items: [
      {
        title: 'Chuyên khoa',
        path: PATH_DASHBOARD.managements.subjects,
        icon: ICONS.label,
        children: [
          {
            id: 'create-subjects',
            title: 'Tạo mới',
            path: PATH_DASHBOARD.managements.subjectForm,
          },
          { title: 'Danh sách', path: PATH_DASHBOARD.managements.subjects, id: 'list-subjects' },
        ],
      },
      {
        title: 'Bác sĩ',
        path: PATH_DASHBOARD.managements.doctors,
        icon: ICONS.user,
        children: [
          {
            title: 'Tạo mới',
            path: `${PATH_DASHBOARD.managements.doctorsForm}`,
            id: 'create-doctors',
          },
          { title: 'Danh sách', path: PATH_DASHBOARD.managements.doctors, id: 'list-doctors' },
        ],
      },
      {
        title: 'Dịch vụ',
        path: PATH_DASHBOARD.managements.services,
        icon: ICONS.menuItem,
        children: [
          { title: 'Tạo mới', path: PATH_DASHBOARD.managements.serviceForm, id: 'create-services' },
          { title: 'Danh sách', path: PATH_DASHBOARD.managements.services, id: 'list-services' },
        ],
      },
      {
        title: 'Cổng thanh toán',
        path: PATH_DASHBOARD.managements.payments,
        icon: ICONS.banking,
        children: [
          {
            title: 'Tạo mới',
            path: `${PATH_DASHBOARD.managements.paymentsForm}`,
            id: 'create-payment',
          },
          { title: 'Danh sách', path: PATH_DASHBOARD.managements.payments, id: 'list-payment' },
        ],
      },
    ],
  },
  {
    subheader: 'Nội dung & Truyền thông',
    items: [
      {
        title: 'Quản lý Nội dung',
        path: PATH_DASHBOARD.managements.cms,
        icon: ICONS.blog,
        children: [
          { title: 'Bài viết', path: PATH_DASHBOARD.managements.articles, id: 'articles' },
          { title: 'Danh mục', path: PATH_DASHBOARD.managements.categories, id: 'categories' },
          {
            title: 'Gói dịch vụ',
            path: PATH_DASHBOARD.managements.packages,
            id: 'packages',
          },
          { title: 'Hướng dẫn', path: PATH_DASHBOARD.managements.guides, id: 'guides' },
          {
            title: 'Trang nội dung',
            path: PATH_DASHBOARD.managements.contents,
            id: 'contents',
          },
          {
            title: 'Biểu ngữ',
            path: PATH_DASHBOARD.managements.cmsBanners,
            id: 'banners',
          },
        ],
      },
      {
        title: 'Biểu ngữ',
        path: PATH_DASHBOARD.managements.banners,
        icon: ICONS.ecommerce,
        children: [
          { title: 'Tạo mới', path: PATH_DASHBOARD.managements.bannersForm, id: 'create-banners' },
          { title: 'Danh sách', path: PATH_DASHBOARD.managements.banners, id: 'list-banners' },
        ],
      },
      {
        title: 'Thư viện phương tiện',
        path: PATH_DASHBOARD.managements.galleries,
        icon: ICONS.folder,
      },
    ],
  },
  {
    subheader: 'Cấu hình chung',
    items: [
      {
        title: 'Bảng quản trị',
        path: PATH_DASHBOARD.managements.auth,
        icon: ICONS.lock,
        children: [
          { title: 'Người dùng', path: PATH_DASHBOARD.managements.users, id: 'users' },
          { title: 'Vai trò', path: PATH_DASHBOARD.managements.roles, id: 'roles' },
        ],
      },
      {
        title: 'Thông tin cơ sở y tế',
        path: '/cau-hinh-chung/thong-tin-co-so-y-te',
        icon: ICONS.file,
      },
    ],
  },
];

export default navConfig;
